import request from "./request";
//lt校验表
export const getPros = (data) => request("/pro/getPros", data, "POST_JSON");
export const getMedias = () => request("/pro/getMedias", null, "POST");
export const ltCheckList = (data) => request("/pro/ltCheckList", data, "POST_JSON");
